import { Platform } from 'react-native';

// Cor de fundo da PÁGINA (o <body>), na web.
//
// A árvore do React ocupa a altura do viewport de quando a tela montou. Quando
// o navegador do celular esconde a barra de endereço o viewport cresce, e a
// faixa que sobra embaixo fica fora do app: quem aparece ali é o fundo do
// <body> — branco por padrão. O mesmo vale para o overscroll.
//
// O padrão é a cor do app (definido no `CustomThemeProvider`). Telas com
// paleta própria — hoje o login — empilham a sua cor por cima enquanto estão
// montadas, e a pilha devolve o padrão quando saem.

let defaultColor = null;
let overrides = 0;

const apply = (color) => {
  if (Platform.OS !== 'web' || typeof document === 'undefined') return;
  document.body.style.backgroundColor = color || '';
};

export function setDefaultPageBackground(color) {
  defaultColor = color;
  // Uma tela com cor própria está no ar: ela manda, senão o tema do app
  // sobrescreveria o login quando ambos resolvessem no mesmo commit.
  if (overrides === 0) apply(color);
}

export function pushPageBackground(color) {
  overrides += 1;
  apply(color);

  return () => {
    overrides = Math.max(0, overrides - 1);
    if (overrides === 0) apply(defaultColor);
  };
}
